import { createSlice } from '@reduxjs/toolkit';

export interface CriticalBalanceAlertModalSliceState {
  isOpen: boolean;
}

const initialState: CriticalBalanceAlertModalSliceState = {
  isOpen: false,
};

const criticalBalanceAlertModalSlice = createSlice({
  name: 'criticalBalanceAlertModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { criticalBalanceAlertModalSlice };
